export default {
  getIsDialogDisplayed(state) {
    return state.isDialogDisplayed;
  },
};
